(() => {
  const initGalleryPopup = (gallery) => {
    if (!gallery || gallery.dataset.wewokPopupReady === 'true') return;
    gallery.dataset.wewokPopupReady = 'true';

    const thumbs = Array.from(gallery.querySelectorAll('[data-wewok-thumb]'));
    const gridItems = Array.from(gallery.querySelectorAll('.wewok-four-image-grid .product__media'));
    const images = thumbs.map((thumb) => ({
      src: thumb.dataset.fullSrc,
      alt: thumb.dataset.alt || ''
    })).filter((item) => item.src);

    if (!images.length) return;

    const modal = document.createElement('div');
    modal.className = 'wewok-image-popup';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = `
      <div class="wewok-image-popup__backdrop" data-wewok-popup-close></div>
      <div class="wewok-image-popup__dialog" role="dialog" aria-modal="true" aria-label="Product image preview">
        <button type="button" class="wewok-image-popup__close" data-wewok-popup-close aria-label="Close image preview">×</button>
        <button type="button" class="wewok-image-popup__nav wewok-image-popup__nav--prev" data-wewok-popup-prev aria-label="Previous image">‹</button>
        <div class="wewok-image-popup__stage">
          <img class="wewok-image-popup__image" alt="">
        </div>
        <button type="button" class="wewok-image-popup__nav wewok-image-popup__nav--next" data-wewok-popup-next aria-label="Next image">›</button>
        <div class="wewok-image-popup__count" aria-live="polite"></div>
      </div>`;
    document.body.appendChild(modal);

    const popupImage = modal.querySelector('.wewok-image-popup__image');
    const count = modal.querySelector('.wewok-image-popup__count');
    let activeIndex = 0;
    let previousFocus = null;

    const showImage = (index) => {
      activeIndex = (index + images.length) % images.length;
      popupImage.src = images[activeIndex].src;
      popupImage.alt = images[activeIndex].alt;
      count.textContent = `${activeIndex + 1} / ${images.length}`;
    };

    const openPopup = (index, trigger) => {
      previousFocus = trigger || document.activeElement;
      showImage(index);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('wewok-popup-open');
      modal.querySelector('.wewok-image-popup__close').focus();
    };

    const closePopup = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('wewok-popup-open');
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    };

    gallery.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-wewok-thumb]');
      if (thumb) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const index = thumbs.indexOf(thumb);
        openPopup(index >= 0 ? index : 0, thumb);
        return;
      }

      const mediaItem = event.target.closest('.wewok-four-image-grid .product__media');
      if (!mediaItem) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const mediaId = mediaItem.dataset.mediaId;
      const matchedThumb = thumbs.find((item) => item.dataset.mediaId === mediaId);
      let index = matchedThumb ? thumbs.indexOf(matchedThumb) : gridItems.indexOf(mediaItem);
      if (index < 0) index = 0;
      openPopup(index, mediaItem);
    }, true);

    modal.addEventListener('click', (event) => {
      if (event.target.closest('[data-wewok-popup-close]')) closePopup();
      if (event.target.closest('[data-wewok-popup-prev]')) showImage(activeIndex - 1);
      if (event.target.closest('[data-wewok-popup-next]')) showImage(activeIndex + 1);
    });

    document.addEventListener('keydown', (event) => {
      if (!modal.classList.contains('is-open')) return;
      if (event.key === 'Escape') closePopup();
      if (event.key === 'ArrowLeft') showImage(activeIndex - 1);
      if (event.key === 'ArrowRight') showImage(activeIndex + 1);
    });
  };

  const initAll = (root = document) => {
    root.querySelectorAll('media-gallery').forEach(initGalleryPopup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();